export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10010.a4db6df7.jpg";